import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const StickyWidgets = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsOpen(false); // Close the dropdown when a language is selected
  };

  return (
    <div className="fixed bottom-8 right-8 flex flex-col items-end space-y-4 z-50">
      {/* WhatsApp Icon */}
      <a
        href="https://wa.me/919426374716" // Replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="group"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          className="w-14 h-14 drop-shadow-lg hover:scale-110 transition-transform"
        />
      </a>

      {/* Language Switcher Button */}
      <div className="relative flex items-center">
      <button
  onClick={() => setIsOpen(!isOpen)}
  className="bg-gradient-to-r from-gray-400 to-gray-700 flex items-center justify-center rounded-full w-16 h-16 shadow-lg hover:shadow-xl hover:from-gray-300 hover:to-gray-700 transition-all transform hover:scale-110 active:scale-100 border-2 border-white"
  aria-label="Change Language"
>
  <img 
    src="/assets/text.png" 
    alt="Change Language" 
    className="w-8 h-8 object-contain"
  />
</button>





        <span className="ml-2 text-gray-800 bg-white px-3 py-1 rounded-md shadow-md">
          {i18n.language.toUpperCase()} {/* Display current language */}
        </span>

        {/* Language Options Dropdown */}
        {isOpen && (
          <div className="absolute bottom-full mb-2 bg-white shadow-lg rounded-lg overflow-hidden">
            <button
              onClick={() => changeLanguage("en")}
              className="flex items-center px-4 py-2 hover:bg-gray-200 text-sm text-gray-800 w-full"
            >
              <img
                src="https://flagcdn.com/w40/gb.png"
                alt="English"
                className="w-5 h-5 mr-2"
              />
              English
            </button>
            <button
              onClick={() => changeLanguage("de")}
              className="flex items-center px-4 py-2 hover:bg-gray-200 text-sm text-gray-800 w-full"
            >
              <img
                src="https://flagcdn.com/w40/de.png"
                alt="German"
                className="w-5 h-5 mr-2"
              />
              German
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default StickyWidgets;
